<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <h5>BENEFICIÁRIOS</h5>
            </b-card-header>
            <b-card-body>
                <app-tabela
                    idTabela="tblBeneficiarios"
                    :itens="beneficiarios"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                >
                    <template slot="cnpj" slot-scope="data">
                        <span v-if="data.cnpj.length == 14">{{ data.cnpj | toCnpj }}</span>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <span class="text-primary" v-if="$temAcessoView('DIRFS-02')">
                            <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhar"
                                @click.stop="detalharBeneficiario(data.dirfBeneficiarioId)"
                            ></i>
                        </span>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
// import DirfsServicos from './DirfsServicos'
// import BtnImportarDirf from './BtnImportarDirf'

export default {
	props: {
		beneficiarios: {
			type: Array,
			default: () => []
		}
	},

	components: {},

	data() {
		return {
			dirfs: [],
			campos: [
				{
					key: 'cnpj',
					label: 'CNPJ',
					sortable: true,
					filterable: true
				},
				{
					key: 'nome',
					label: 'Beneficiário',
					sortable: true,
					filterable: true
				},
				{
					key: 'acoes',
					label: 'Ações'
				}
			],
			itensPorPagina: 10
		}
	},

	methods: {
		detalharBeneficiario(dirfBeneficiarioId) {
			this.$router.push({
				name: 'Dirfs_Detalhar_Beneficiario',
				params: {
					dirfBeneficiarioId
				}
			})
		}
	},

	created() {},

	computed: {},

	watch: {}
}
</script>
